module.exports = __webpack_public_path__ + "media/application/images/2018/health-insurance-policies-hero_large-966d1b3900aab5f7c2e9bffa02f228a4.jpg";